module.exports = __webpack_public_path__ + "img/icon-indice-cronologico.aff95fec.png";